
export {} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$slider.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$slider.js';export default __x__;